import actions from './actions';

const {
  STORE_MARKETING_EXPENSE_BEGIN,
  STORE_MARKETING_EXPENSE_SUCCESS,
  STORE_MARKETING_EXPENSE_ERR,
  STORE_MARKETING_IMAGES_GALLERY_BEGIN,
  STORE_MARKETING_IMAGES_GALLERY_SUCCESS,
  STORE_MARKETING_IMAGES_GALLERY_ERR,
} = actions;

const initialState = { data: null, dataMonth: null, overviewData: null, overviewYear: null, requestedMonth: null, loading: false, error: null };

export const storeMarketingExpenseReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STORE_MARKETING_EXPENSE_BEGIN:
      return { ...state, requestedMonth: action.month, loading: true, error: null };
    case STORE_MARKETING_EXPENSE_SUCCESS:
      if (action.month !== state.requestedMonth) return state;
      return {
        ...state,
        data,
        dataMonth: action.month,
        overviewData: action.overviewYear == null ? state.overviewData : data,
        overviewYear: action.overviewYear == null ? state.overviewYear : action.overviewYear,
        loading: false,
        error: null,
      };
    case STORE_MARKETING_EXPENSE_ERR:
      if (action.month !== state.requestedMonth) return state;
      return { ...state, loading: false, error: err };
    default:
      return state;
  }
};

const galleryInitialState = {
  data: null,
  dataMonth: null,
  requestedMonth: null,
  loading: false,
  error: null,
};

export const storeMarketingImagesGalleryReducer = (state = galleryInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STORE_MARKETING_IMAGES_GALLERY_BEGIN:
      return { ...state, requestedMonth: action.month, loading: true, error: null };
    case STORE_MARKETING_IMAGES_GALLERY_SUCCESS:
      if (action.month !== state.requestedMonth) return state;
      return {
        ...state,
        data,
        dataMonth: action.month,
        loading: false,
        error: null,
      };
    case STORE_MARKETING_IMAGES_GALLERY_ERR:
      if (action.month !== state.requestedMonth) return state;
      return { ...state, loading: false, error: err };
    default:
      return state;
  }
};
